import { Drawer } from '@mui/material';

function QueryAdderDrawer({ children, openForm, setOpenForm }) {
  return (
    <Drawer
      open={openForm}
      onClose={() => setOpenForm(false)}
      PaperProps={{
        sx: {
          backgroundColor: 'white',
          borderRadius: '25px',
          width: '60vw',
          minWidth: '1200px',
          p: '20px 40px',
        },
      }}
      disableEnforceFocus
      anchor="right"
    >
      {children}
    </Drawer>
  );
}

export default QueryAdderDrawer;
